import { useTranslation } from 'react-i18next';
import React from 'react';
import styled, { keyframes } from 'styled-components';

export const LoadingText = () => {
  const { t } = useTranslation();

  return <Loader>Loading </Loader>;
};
export default LoadingText;

// Keyframes for animation
const animLoader = keyframes`
  0% {
    box-shadow: 10px 0 rgba(255, 255, 255, 0), 20px 0 rgba(255, 255, 255, 0);
  }
  50% {
    box-shadow: 10px 0 #163b6a, 20px 0 rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 10px 0 #163b6a, 20px 0 #163b6a;
  }
  `;

// Styled Loader Component
const Loader = styled.span`
  color: #163b6a;
  display: inline-block;
  position: relative;
  font-size: 20px;
  box-sizing: border-box;

  &::after {
    content: '';
    width: 3px;
    height: 3px;
    background: currentColor;
    position: absolute;
    bottom: 5px;
    right: -5px;
    box-sizing: border-box;
    animation: ${animLoader} 1s linear infinite;
  }
`;
